// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assessments-page {
  --assessment-blue: #263f86;
  --assessment-blue-dark: #19316f;
  --assessment-text: #172033;
  --assessment-muted: #5f6b7a;
  --assessment-border: #dce3ef;
  --assessment-surface: #ffffff;
  max-width: 1280px;
  min-height: calc(100vh - 20px);
  margin: 10px auto;
  padding: 30px;
  border-radius: 24px;
  background:
    radial-gradient(circle at 95% 4%, rgba(38, 63, 134, 0.1), transparent 24%),
    #f5f7fb;
  color: var(--assessment-text);
  font-family: "Manrope-Regular", sans-serif;
}

.assessments-page__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 24px;
}

.assessments-page__heading-group {
  display: flex;
  align-items: center;
  gap: 24px;
  min-width: 0;
}

.assessments-page__back-button {
  width: 46px;
  height: 46px;
  flex: 0 0 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--assessment-border);
  border-radius: 14px;
  background: var(--assessment-surface);
  color: var(--assessment-blue);
  box-shadow: 0 6px 18px rgba(23, 32, 51, 0.07);
  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}

.assessments-page__back-button:hover {
  transform: translateX(-2px);
  border-color: #aebbd2;
  box-shadow: 0 8px 22px rgba(23, 32, 51, 0.11);
}

.assessments-page__title-copy {
  min-width: 0;
}

.assessments-page__eyebrow {
  display: block;
  margin-bottom: 3px;
  color: var(--assessment-blue);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.assessments-page__title-copy h1 {
  margin: 0;
  color: var(--assessment-text);
  font-size: clamp(24px, 3vw, 32px);
  font-weight: 800;
  letter-spacing: -0.035em;
}

.assessments-page__title-copy p {
  margin: 4px 0 0;
  color: var(--assessment-muted);
  font-size: 14px;
}

.assessments-page__module-pill {
  min-width: 190px;
  padding: 9px 13px;
  border: 1px solid #d8e0f0;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.72);
}

.assessments-page__module-pill span,
.assessments-page__module-pill strong {
  display: block;
}

.assessments-page__module-pill span {
  margin-bottom: 2px;
  color: var(--assessment-muted);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.assessments-page__module-pill strong {
  overflow: hidden;
  color: #27344a;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.assessments-page__add-button.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  flex-shrink: 0;
  min-height: 46px;
  padding: 11px 18px;
  border: 1px solid var(--assessment-blue);
  border-radius: 13px;
  background: var(--assessment-blue);
  color: #ffffff;
  font-weight: 800;
  box-shadow: 0 10px 24px rgba(38, 63, 134, 0.22);
  transition: transform 160ms ease, background-color 160ms ease, box-shadow 160ms ease;
}

.assessments-page__add-button.btn:hover,
.assessments-page__add-button.btn:active {
  transform: translateY(-1px);
  border-color: var(--assessment-blue-dark);
  background: var(--assessment-blue-dark);
  color: #ffffff;
  box-shadow: 0 12px 28px rgba(38, 63, 134, 0.3);
}

.assessments-page__surface {
  min-height: 220px;
  padding: 24px;
  border: 1px solid var(--assessment-border);
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 16px 40px rgba(23, 32, 51, 0.07);
}

.assessment-list__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 18px;
}

.assessment-list__header h2 {
  margin: 0;
  color: var(--assessment-text);
  font-size: 18px;
  font-weight: 800;
}

.assessment-list__header p {
  margin: 4px 0 0;
  color: var(--assessment-muted);
  font-size: 13px;
}

.assessment-list__count {
  min-width: 38px;
  padding: 6px 10px;
  border: 1px solid #d8e0f0;
  border-radius: 999px;
  background: #eef2ff;
  color: var(--assessment-blue);
  font-size: 12px;
  font-weight: 800;
  text-align: center;
}

.assessment-list {
  display: grid;
  gap: 14px;
}

.assessment-card {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 24px;
  align-items: center;
  padding: 20px;
  border: 1px solid var(--assessment-border);
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 5px 16px rgba(23, 32, 51, 0.045);
  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}

.assessment-card:hover {
  transform: translateY(-2px);
  border-color: #b9c5db;
  box-shadow: 0 12px 28px rgba(23, 32, 51, 0.09);
}

.assessment-card__identity {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  min-width: 0;
}

.assessment-card__icon {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
  background: #eef2ff;
  color: var(--assessment-blue);
}

.assessment-card__copy {
  min-width: 0;
}

.assessment-card__meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 5px;
}

.assessment-card__type {
  color: var(--assessment-blue);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.assessment-card__status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.assessment-card__status--published {
  background: #e8f5ef;
  color: #0f654c;
}

.assessment-card__status--draft {
  background: #fff3dc;
  color: #704300;
}

.assessment-card__copy h3 {
  overflow: hidden;
  margin: 0;
  color: var(--assessment-text);
  font-size: 16px;
  font-weight: 800;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.assessment-card__copy p {
  display: -webkit-box;
  overflow: hidden;
  margin: 5px 0 0;
  color: var(--assessment-muted);
  font-size: 12px;
  line-height: 1.5;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.assessment-card__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.assessment-card__primary.btn,
.assessment-card__secondary.btn,
.assessment-card__menu-button.btn {
  min-height: 40px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 800;
}

.assessment-card__primary.btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 13px;
  border-color: var(--assessment-blue);
  background: var(--assessment-blue);
  color: #ffffff;
}

.assessment-card__primary.btn:hover,
.assessment-card__primary.btn:active {
  border-color: var(--assessment-blue-dark);
  background: var(--assessment-blue-dark);
  color: #ffffff;
}

.assessment-card__secondary.btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 12px;
  border-color: #aeb9ca;
  background: #ffffff;
  color: #334155;
}

.assessment-card__secondary.btn:hover,
.assessment-card__secondary.btn:active {
  border-color: #7f8da3;
  background: #f4f6fa;
  color: #172033;
}

.assessment-card__menu-button.btn {
  width: 40px;
  padding: 0;
  border: 1px solid transparent;
  background: transparent;
  color: #334155;
}

.assessment-card__menu-button.btn::after {
  display: none;
}

.assessment-card__menu-button.btn:hover,
.assessment-card__menu-button.btn:active,
.assessment-card__menu-button.btn.show {
  border-color: var(--assessment-border);
  background: #eef2f7;
  color: #172033;
}

.assessment-card__menu .dropdown-menu {
  padding: 7px;
  border: 1px solid var(--assessment-border);
  border-radius: 12px;
  box-shadow: 0 14px 32px rgba(23, 32, 51, 0.14);
}

.assessment-card__menu .dropdown-item {
  display: flex;
  align-items: center;
  min-height: 40px;
  border-radius: 8px;
  color: #27344a;
  font-size: 13px;
  font-weight: 700;
}

.assessment-empty,
.assessment-loading {
  display: flex;
  min-height: 260px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  color: var(--assessment-muted);
  text-align: center;
}

.assessment-empty__icon {
  width: 58px;
  height: 58px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
  border-radius: 17px;
  background: #eef2ff;
  color: var(--assessment-blue);
}

.assessment-empty h2 {
  margin: 0 0 6px;
  color: var(--assessment-text);
  font-size: 18px;
  font-weight: 800;
}

.assessment-empty p {
  max-width: 420px;
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
}

.assessment-edit-dialog {
  max-width: 720px;
}

.assessment-create-dialog {
  max-width: 640px;
}

.assessment-edit-modal .modal-content {
  overflow: hidden;
  border: 0;
  border-radius: 22px;
  box-shadow: 0 22px 60px rgba(23, 32, 51, 0.2);
}

.assessment-edit-modal .modal-header {
  align-items: flex-start;
  padding: 22px 26px 18px;
  background: #ffffff;
}

.assessment-edit-modal .modal-title {
  padding-right: 20px;
}

.assessment-edit-modal__title,
.assessment-edit-modal__subtitle {
  display: block;
}

.assessment-edit-modal__title {
  color: #172033;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.025em;
}

.assessment-edit-modal__subtitle {
  margin-top: 4px;
  color: #5f6b7a;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
}

.assessment-edit-modal .btn-close {
  margin-top: 2px;
}

.assessment-edit-modal .modal-body {
  padding: 24px 26px 28px;
  background: #fbfcfe;
}

.assessment-edit-modal .modal-header,
.assessment-edit-modal .modal-footer {
  border-color: #dce3ef;
}

.assessment-edit-modal__field {
  margin-bottom: 20px;
}

.assessment-edit-modal .form-label {
  margin-bottom: 7px;
  color: #334155;
  font-size: 13px;
  font-weight: 800;
}

.assessment-edit-modal .form-label span,
.assessment-edit-modal__required-note span {
  color: #b42323;
}

.assessment-edit-modal .form-control,
.assessment-edit-modal .form-select {
  min-height: 46px;
  border-color: #b9c4d4;
  border-radius: 11px;
  background-color: #ffffff;
  color: #172033;
  font-size: 14px;
}

.assessment-edit-modal textarea.form-control {
  min-height: 112px;
  resize: vertical;
}

.assessment-edit-modal .form-control:hover,
.assessment-edit-modal .form-select:hover {
  border-color: #8795aa;
}

.assessment-edit-modal .form-control:focus,
.assessment-edit-modal .form-select:focus {
  border-color: #263f86;
  box-shadow: 0 0 0 3px rgba(38, 63, 134, 0.14);
}

.assessment-edit-modal .form-text {
  display: block;
  margin-top: 6px;
  color: #5f6b7a;
  font-size: 11px;
}

.assessment-edit-modal__label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.assessment-edit-modal__label-row > span {
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
}

.assessment-edit-modal__grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 18px;
  padding-top: 2px;
}

.assessment-edit-modal .modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 26px;
  background: #ffffff;
}

.assessment-edit-modal__required-note {
  color: #5f6b7a;
  font-size: 11px;
  font-weight: 600;
}

.assessment-edit-modal__footer-actions {
  display: flex;
  align-items: center;
  gap: 9px;
}

.assessment-edit-modal__footer-actions .btn {
  min-height: 42px;
  padding: 9px 16px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 800;
}

.assessment-edit-modal__footer-actions .btn-light {
  border: 1px solid #d2dae6;
  background: #ffffff;
  color: #334155;
}

.assessment-edit-modal__footer-actions .btn-light:hover {
  border-color: #aeb9ca;
  background: #f3f5f8;
  color: #172033;
}

.assessment-edit-modal__save.btn {
  border-color: #263f86;
  background: #263f86;
  color: #ffffff;
}

.assessment-edit-modal__save.btn:hover,
.assessment-edit-modal__save.btn:active {
  border-color: #19316f;
  background: #19316f;
  color: #ffffff;
}

.assessment-edit-modal__save.btn:disabled {
  border-color: #64748b;
  background: #64748b;
  color: #ffffff;
  opacity: 1;
}

@media (max-width: 900px) {
  .assessments-page {
    padding: 22px;
  }

  .assessments-page__heading-group {
    align-items: flex-start;
    flex-direction: column;
    gap: 14px;
  }

  .assessments-page__module-pill {
    max-width: 100%;
    margin-left: 61px;
  }

  .assessment-card {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .assessment-card__actions {
    padding-left: 57px;
  }
}

@media (max-width: 576px) {
  .assessments-page {
    min-height: 100vh;
    margin: 0;
    padding: 18px 14px;
    border-radius: 0;
  }

  .assessments-page__header {
    align-items: stretch;
    flex-direction: column;
  }

  .assessments-page__heading-group {
    gap: 12px;
  }

  .assessments-page__module-pill {
    width: calc(100% - 59px);
    margin-left: 59px;
  }

  .assessments-page__add-button.btn {
    width: 100%;
  }

  .assessments-page__surface {
    padding: 15px;
    border-radius: 17px;
  }

  .assessment-card {
    padding: 16px;
  }

  .assessment-card__actions {
    display: grid;
    grid-template-columns: 1fr 1fr 40px;
    padding-left: 0;
  }

  .assessment-card__primary.btn,
  .assessment-card__secondary.btn {
    justify-content: center;
  }

  .assessment-edit-modal .modal-dialog {
    margin: 10px;
  }

  .assessment-edit-modal .modal-header,
  .assessment-edit-modal .modal-body,
  .assessment-edit-modal .modal-footer {
    padding-right: 18px;
    padding-left: 18px;
  }

  .assessment-edit-modal__grid {
    grid-template-columns: 1fr;
  }

  .assessment-edit-modal .modal-footer {
    align-items: stretch;
    flex-direction: column;
  }

  .assessment-edit-modal__footer-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .assessments-page__back-button,
  .assessments-page__add-button.btn,
  .assessment-card {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/AssessmentsPage.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;EACjB,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB;;WAES;EACT,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,6BAA6B;EAC7B,6CAA6C;EAC7C,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,iCAAiC;EACjC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,+CAA+C;EAC/C,oFAAoF;AACtF;;AAEA;;EAEE,2BAA2B;EAC3B,yCAAyC;EACzC,uCAAuC;EACvC,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;EAEE,yCAAyC;EACzC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mCAAmC;IACnC,eAAe;EACjB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA;;;IAGE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;AACF;;AAEA;EACE;;;IAGE,gBAAgB;EAClB;AACF","sourcesContent":[".assessments-page {\n  --assessment-blue: #263f86;\n  --assessment-blue-dark: #19316f;\n  --assessment-text: #172033;\n  --assessment-muted: #5f6b7a;\n  --assessment-border: #dce3ef;\n  --assessment-surface: #ffffff;\n  max-width: 1280px;\n  min-height: calc(100vh - 20px);\n  margin: 10px auto;\n  padding: 30px;\n  border-radius: 24px;\n  background:\n    radial-gradient(circle at 95% 4%, rgba(38, 63, 134, 0.1), transparent 24%),\n    #f5f7fb;\n  color: var(--assessment-text);\n  font-family: \"Manrope-Regular\", sans-serif;\n}\n\n.assessments-page__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n.assessments-page__heading-group {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  min-width: 0;\n}\n\n.assessments-page__back-button {\n  width: 46px;\n  height: 46px;\n  flex: 0 0 46px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--assessment-border);\n  border-radius: 14px;\n  background: var(--assessment-surface);\n  color: var(--assessment-blue);\n  box-shadow: 0 6px 18px rgba(23, 32, 51, 0.07);\n  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.assessments-page__back-button:hover {\n  transform: translateX(-2px);\n  border-color: #aebbd2;\n  box-shadow: 0 8px 22px rgba(23, 32, 51, 0.11);\n}\n\n.assessments-page__title-copy {\n  min-width: 0;\n}\n\n.assessments-page__eyebrow {\n  display: block;\n  margin-bottom: 3px;\n  color: var(--assessment-blue);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.assessments-page__title-copy h1 {\n  margin: 0;\n  color: var(--assessment-text);\n  font-size: clamp(24px, 3vw, 32px);\n  font-weight: 800;\n  letter-spacing: -0.035em;\n}\n\n.assessments-page__title-copy p {\n  margin: 4px 0 0;\n  color: var(--assessment-muted);\n  font-size: 14px;\n}\n\n.assessments-page__module-pill {\n  min-width: 190px;\n  padding: 9px 13px;\n  border: 1px solid #d8e0f0;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.72);\n}\n\n.assessments-page__module-pill span,\n.assessments-page__module-pill strong {\n  display: block;\n}\n\n.assessments-page__module-pill span {\n  margin-bottom: 2px;\n  color: var(--assessment-muted);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.assessments-page__module-pill strong {\n  overflow: hidden;\n  color: #27344a;\n  font-size: 13px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.assessments-page__add-button.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  flex-shrink: 0;\n  min-height: 46px;\n  padding: 11px 18px;\n  border: 1px solid var(--assessment-blue);\n  border-radius: 13px;\n  background: var(--assessment-blue);\n  color: #ffffff;\n  font-weight: 800;\n  box-shadow: 0 10px 24px rgba(38, 63, 134, 0.22);\n  transition: transform 160ms ease, background-color 160ms ease, box-shadow 160ms ease;\n}\n\n.assessments-page__add-button.btn:hover,\n.assessments-page__add-button.btn:active {\n  transform: translateY(-1px);\n  border-color: var(--assessment-blue-dark);\n  background: var(--assessment-blue-dark);\n  color: #ffffff;\n  box-shadow: 0 12px 28px rgba(38, 63, 134, 0.3);\n}\n\n.assessments-page__surface {\n  min-height: 220px;\n  padding: 24px;\n  border: 1px solid var(--assessment-border);\n  border-radius: 22px;\n  background: rgba(255, 255, 255, 0.94);\n  box-shadow: 0 16px 40px rgba(23, 32, 51, 0.07);\n}\n\n.assessment-list__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 18px;\n}\n\n.assessment-list__header h2 {\n  margin: 0;\n  color: var(--assessment-text);\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.assessment-list__header p {\n  margin: 4px 0 0;\n  color: var(--assessment-muted);\n  font-size: 13px;\n}\n\n.assessment-list__count {\n  min-width: 38px;\n  padding: 6px 10px;\n  border: 1px solid #d8e0f0;\n  border-radius: 999px;\n  background: #eef2ff;\n  color: var(--assessment-blue);\n  font-size: 12px;\n  font-weight: 800;\n  text-align: center;\n}\n\n.assessment-list {\n  display: grid;\n  gap: 14px;\n}\n\n.assessment-card {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 24px;\n  align-items: center;\n  padding: 20px;\n  border: 1px solid var(--assessment-border);\n  border-radius: 16px;\n  background: #ffffff;\n  box-shadow: 0 5px 16px rgba(23, 32, 51, 0.045);\n  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.assessment-card:hover {\n  transform: translateY(-2px);\n  border-color: #b9c5db;\n  box-shadow: 0 12px 28px rgba(23, 32, 51, 0.09);\n}\n\n.assessment-card__identity {\n  display: flex;\n  align-items: flex-start;\n  gap: 15px;\n  min-width: 0;\n}\n\n.assessment-card__icon {\n  width: 42px;\n  height: 42px;\n  flex: 0 0 42px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 13px;\n  background: #eef2ff;\n  color: var(--assessment-blue);\n}\n\n.assessment-card__copy {\n  min-width: 0;\n}\n\n.assessment-card__meta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 5px;\n}\n\n.assessment-card__type {\n  color: var(--assessment-blue);\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n}\n\n.assessment-card__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 8px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n}\n\n.assessment-card__status--published {\n  background: #e8f5ef;\n  color: #0f654c;\n}\n\n.assessment-card__status--draft {\n  background: #fff3dc;\n  color: #704300;\n}\n\n.assessment-card__copy h3 {\n  overflow: hidden;\n  margin: 0;\n  color: var(--assessment-text);\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 1.4;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.assessment-card__copy p {\n  display: -webkit-box;\n  overflow: hidden;\n  margin: 5px 0 0;\n  color: var(--assessment-muted);\n  font-size: 12px;\n  line-height: 1.5;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n}\n\n.assessment-card__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.assessment-card__primary.btn,\n.assessment-card__secondary.btn,\n.assessment-card__menu-button.btn {\n  min-height: 40px;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.assessment-card__primary.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 9px 13px;\n  border-color: var(--assessment-blue);\n  background: var(--assessment-blue);\n  color: #ffffff;\n}\n\n.assessment-card__primary.btn:hover,\n.assessment-card__primary.btn:active {\n  border-color: var(--assessment-blue-dark);\n  background: var(--assessment-blue-dark);\n  color: #ffffff;\n}\n\n.assessment-card__secondary.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 9px 12px;\n  border-color: #aeb9ca;\n  background: #ffffff;\n  color: #334155;\n}\n\n.assessment-card__secondary.btn:hover,\n.assessment-card__secondary.btn:active {\n  border-color: #7f8da3;\n  background: #f4f6fa;\n  color: #172033;\n}\n\n.assessment-card__menu-button.btn {\n  width: 40px;\n  padding: 0;\n  border: 1px solid transparent;\n  background: transparent;\n  color: #334155;\n}\n\n.assessment-card__menu-button.btn::after {\n  display: none;\n}\n\n.assessment-card__menu-button.btn:hover,\n.assessment-card__menu-button.btn:active,\n.assessment-card__menu-button.btn.show {\n  border-color: var(--assessment-border);\n  background: #eef2f7;\n  color: #172033;\n}\n\n.assessment-card__menu .dropdown-menu {\n  padding: 7px;\n  border: 1px solid var(--assessment-border);\n  border-radius: 12px;\n  box-shadow: 0 14px 32px rgba(23, 32, 51, 0.14);\n}\n\n.assessment-card__menu .dropdown-item {\n  display: flex;\n  align-items: center;\n  min-height: 40px;\n  border-radius: 8px;\n  color: #27344a;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.assessment-empty,\n.assessment-loading {\n  display: flex;\n  min-height: 260px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n  color: var(--assessment-muted);\n  text-align: center;\n}\n\n.assessment-empty__icon {\n  width: 58px;\n  height: 58px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 14px;\n  border-radius: 17px;\n  background: #eef2ff;\n  color: var(--assessment-blue);\n}\n\n.assessment-empty h2 {\n  margin: 0 0 6px;\n  color: var(--assessment-text);\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.assessment-empty p {\n  max-width: 420px;\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.6;\n}\n\n.assessment-edit-dialog {\n  max-width: 720px;\n}\n\n.assessment-create-dialog {\n  max-width: 640px;\n}\n\n.assessment-edit-modal .modal-content {\n  overflow: hidden;\n  border: 0;\n  border-radius: 22px;\n  box-shadow: 0 22px 60px rgba(23, 32, 51, 0.2);\n}\n\n.assessment-edit-modal .modal-header {\n  align-items: flex-start;\n  padding: 22px 26px 18px;\n  background: #ffffff;\n}\n\n.assessment-edit-modal .modal-title {\n  padding-right: 20px;\n}\n\n.assessment-edit-modal__title,\n.assessment-edit-modal__subtitle {\n  display: block;\n}\n\n.assessment-edit-modal__title {\n  color: #172033;\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: -0.025em;\n}\n\n.assessment-edit-modal__subtitle {\n  margin-top: 4px;\n  color: #5f6b7a;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.5;\n}\n\n.assessment-edit-modal .btn-close {\n  margin-top: 2px;\n}\n\n.assessment-edit-modal .modal-body {\n  padding: 24px 26px 28px;\n  background: #fbfcfe;\n}\n\n.assessment-edit-modal .modal-header,\n.assessment-edit-modal .modal-footer {\n  border-color: #dce3ef;\n}\n\n.assessment-edit-modal__field {\n  margin-bottom: 20px;\n}\n\n.assessment-edit-modal .form-label {\n  margin-bottom: 7px;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.assessment-edit-modal .form-label span,\n.assessment-edit-modal__required-note span {\n  color: #b42323;\n}\n\n.assessment-edit-modal .form-control,\n.assessment-edit-modal .form-select {\n  min-height: 46px;\n  border-color: #b9c4d4;\n  border-radius: 11px;\n  background-color: #ffffff;\n  color: #172033;\n  font-size: 14px;\n}\n\n.assessment-edit-modal textarea.form-control {\n  min-height: 112px;\n  resize: vertical;\n}\n\n.assessment-edit-modal .form-control:hover,\n.assessment-edit-modal .form-select:hover {\n  border-color: #8795aa;\n}\n\n.assessment-edit-modal .form-control:focus,\n.assessment-edit-modal .form-select:focus {\n  border-color: #263f86;\n  box-shadow: 0 0 0 3px rgba(38, 63, 134, 0.14);\n}\n\n.assessment-edit-modal .form-text {\n  display: block;\n  margin-top: 6px;\n  color: #5f6b7a;\n  font-size: 11px;\n}\n\n.assessment-edit-modal__label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.assessment-edit-modal__label-row > span {\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.assessment-edit-modal__grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 18px;\n  padding-top: 2px;\n}\n\n.assessment-edit-modal .modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px 26px;\n  background: #ffffff;\n}\n\n.assessment-edit-modal__required-note {\n  color: #5f6b7a;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.assessment-edit-modal__footer-actions {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n}\n\n.assessment-edit-modal__footer-actions .btn {\n  min-height: 42px;\n  padding: 9px 16px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.assessment-edit-modal__footer-actions .btn-light {\n  border: 1px solid #d2dae6;\n  background: #ffffff;\n  color: #334155;\n}\n\n.assessment-edit-modal__footer-actions .btn-light:hover {\n  border-color: #aeb9ca;\n  background: #f3f5f8;\n  color: #172033;\n}\n\n.assessment-edit-modal__save.btn {\n  border-color: #263f86;\n  background: #263f86;\n  color: #ffffff;\n}\n\n.assessment-edit-modal__save.btn:hover,\n.assessment-edit-modal__save.btn:active {\n  border-color: #19316f;\n  background: #19316f;\n  color: #ffffff;\n}\n\n.assessment-edit-modal__save.btn:disabled {\n  border-color: #64748b;\n  background: #64748b;\n  color: #ffffff;\n  opacity: 1;\n}\n\n@media (max-width: 900px) {\n  .assessments-page {\n    padding: 22px;\n  }\n\n  .assessments-page__heading-group {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 14px;\n  }\n\n  .assessments-page__module-pill {\n    max-width: 100%;\n    margin-left: 61px;\n  }\n\n  .assessment-card {\n    grid-template-columns: 1fr;\n    gap: 18px;\n  }\n\n  .assessment-card__actions {\n    padding-left: 57px;\n  }\n}\n\n@media (max-width: 576px) {\n  .assessments-page {\n    min-height: 100vh;\n    margin: 0;\n    padding: 18px 14px;\n    border-radius: 0;\n  }\n\n  .assessments-page__header {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .assessments-page__heading-group {\n    gap: 12px;\n  }\n\n  .assessments-page__module-pill {\n    width: calc(100% - 59px);\n    margin-left: 59px;\n  }\n\n  .assessments-page__add-button.btn {\n    width: 100%;\n  }\n\n  .assessments-page__surface {\n    padding: 15px;\n    border-radius: 17px;\n  }\n\n  .assessment-card {\n    padding: 16px;\n  }\n\n  .assessment-card__actions {\n    display: grid;\n    grid-template-columns: 1fr 1fr 40px;\n    padding-left: 0;\n  }\n\n  .assessment-card__primary.btn,\n  .assessment-card__secondary.btn {\n    justify-content: center;\n  }\n\n  .assessment-edit-modal .modal-dialog {\n    margin: 10px;\n  }\n\n  .assessment-edit-modal .modal-header,\n  .assessment-edit-modal .modal-body,\n  .assessment-edit-modal .modal-footer {\n    padding-right: 18px;\n    padding-left: 18px;\n  }\n\n  .assessment-edit-modal__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .assessment-edit-modal .modal-footer {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .assessment-edit-modal__footer-actions {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    width: 100%;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .assessments-page__back-button,\n  .assessments-page__add-button.btn,\n  .assessment-card {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
